// extracted by mini-css-extract-plugin
export default {"sideContent":"ciBPJZIN75RBSd_LLeQe","cardContent":"sJ0vFvcAJtwFgzBB0NJh","description":"qSexdB_SwN8veXI325QF"};